/**
 * @generated SignedSource<<459e2f30c71e20720d687b4b9fcebeec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type stakeholderRow_stakeholder$data = {
  readonly id: string;
  readonly monthlyCosts: ReadonlyArray<{
    readonly amount: number;
    readonly month: string;
  }>;
  readonly name: string;
  readonly streams?: ReadonlyArray<{
    readonly createdAt: any;
    readonly flows: ReadonlyArray<{
      readonly amount: number;
      readonly date: any | null | undefined;
      readonly kind: string;
    }>;
    readonly id: string;
    readonly morph: {
      readonly id: string;
      readonly kind: string;
    };
  }>;
  readonly txns?: ReadonlyArray<{
    readonly amount: number | null | undefined;
    readonly bankAccount: {
      readonly bank: {
        readonly iconSvg: string;
        readonly name: string;
      };
      readonly id: string;
      readonly last4: string | null | undefined;
      readonly nickname: string;
    } | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly kind: string;
    readonly postingDate: any;
  }>;
  readonly " $fragmentType": "stakeholderRow_stakeholder";
};
export type stakeholderRow_stakeholder$key = {
  readonly " $data"?: stakeholderRow_stakeholder$data;
  readonly " $fragmentSpreads": FragmentRefs<"stakeholderRow_stakeholder">;
};

import StakeholderRowRefetchQuery_graphql from './StakeholderRowRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDate"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "loadDetails"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": StakeholderRowRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "stakeholderRow_stakeholder",
  "selections": [
    (v0/*: any*/),
    {
      "condition": "loadDetails",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Txn",
          "kind": "LinkedField",
          "name": "txns",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "postingDate",
              "storageKey": null
            },
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BankAccount",
              "kind": "LinkedField",
              "name": "bankAccount",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "last4",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "nickname",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Bank",
                  "kind": "LinkedField",
                  "name": "bank",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "iconSvg",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Stream",
          "kind": "LinkedField",
          "name": "streams",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Morph",
              "kind": "LinkedField",
              "name": "morph",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Flow",
              "kind": "LinkedField",
              "name": "flows",
              "plural": true,
              "selections": [
                (v3/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "endDate",
          "variableName": "endDate"
        },
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "concreteType": "MonthlyCost",
      "kind": "LinkedField",
      "name": "monthlyCosts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "month",
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Stakeholder",
  "abstractKey": null
};
})();

(node as any).hash = "928e8dd3ba9bf143f5c1cb0e0221365a";

export default node;
